/*
  This is the product image that displays when selecting a product. Clicking on the image opens
  a modal of the image.
 */

import React from 'react';
import { connect } from "react-redux";

class ProductImage extends React.Component {

    state = {
        modalVisible: false
    };

    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
        e.preventDefault();
        // make the modal visible on click
        if(!this.state.modalVisible) {
            this.setState({
                modalVisible: true
            });
        }
    }

    handleClose(e){
        e.preventDefault();
        if(this.state.modalVisible) {
            // close modal on escape key press
            if(e.keyCode === 27) {
                this.setState({
                    modalVisible: false
                });
            }
        }
    }

    renderImage() {
        // product image is either undefined or {}
        if(!this.props.productImage || !Object.keys(this.props.productImage).length) {
            return;
        }
        return <img src={window.location.origin + this.props.productImage.thumb} style={{height:'auto', width: '100%'}} />;

    }

    renderModal() {
        if(!this.state.modalVisible){
            return null;
        }
        const imageStyles = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '600px',
            height: 'auto',
            backgroundColor: 'black',

        };

        const overlayStyle = {
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            zIndex: '100'
        };

        return (
            <div className="modal-popup" style={overlayStyle}>
                <img src={window.location.origin + this.props.productImage.full} style={imageStyles}/>;
            </div>
        )
    }
    render() {
        return (
            <div className="product-image-wrapper" tabIndex="0" onKeyDown={(e) => this.handleClose(e)} onClick={(e) => this.handleClick(e)}>
                { this.renderImage()}
                {this.renderModal() }
            </div>
        )
    }
}

const mapStateToProps = state =>{
    return {
        productImage: state.productImage
    }
};

export default connect(mapStateToProps)(ProductImage);